import Image from '@/components/Image';
import styles from './common.module.scss';

interface BannerProps {
  mobile?: {
    banner_img: string;
    title: string;
    title_color: string;
    content: string;
    content_color: string;
  } | null;
  pc?: {
    banner_img: string;
    title: string;
    title_color: string;
    content: string;
    content_color: string;
  } | null;
  isMobile?: boolean;
}

export default function Banner({ mobile, pc, isMobile = false }: BannerProps) {
  // 根据设备类型选择数据
  const bannerData = isMobile ? mobile : pc;

  if (!bannerData) return null;

  return (
    <div className="relative w-full h-full">
      <Image
        src={bannerData.banner_img}
        alt={bannerData.title}
        className="block w-full h-auto"
        width={1920}
        height={686}
      />
      <div className="px-[16px] absolute left-1/2 w-full transform -translate-x-1/2 md:translate-x-0 top-[32px] md:left-[2.5%] md:top-1/2 md:transform md:-translate-y-1/2 md:w-[95%] px-4 box-border">
        <div className="text-center md:text-left">
          <h1
            className={`${styles['max-line-2']} font-bb text-[24px] leading-[29px] text-center md:text-left md:text-[clamp(20px,2.92vw,56px)] md:leading-[clamp(20px,3.49vw,67px)]`}
            style={{ color: bannerData.title_color, fontFamily: 'var(--font-bricolage-bold)' }}
            dangerouslySetInnerHTML={{ __html: bannerData.title }}
          />
          <div
            className={`${styles['max-line-2']} text-[13px] leading-[20px] mt-[13px] text-center md:text-left md:text-[clamp(14px,1.2vw,16px)] md:leading-[clamp(14px,1.4vw,19px)] md:mt-16`}
            style={{ color: bannerData.content_color }}
            dangerouslySetInnerHTML={{ __html: bannerData.content }}
          />
        </div>
      </div>
    </div>
  );
}
